import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { buildRangeDateObject } from '../../helpers/buildDateObject';
import { Ui2DatePickerModel } from '../../models/date-picker.model';

@Component({
  selector: 'ui2-datepicker-range',
  templateUrl: './ui2-datepicker-range.component.html',
  styleUrls: ['./ui2-datepicker-range.component.scss', '../../styles/date-picker-trigger.scss']
})
export class Ui2DatepickerRangeComponent {
  @Input()
  set datePickerModel(datePickerModel: Ui2DatePickerModel) {
    this.selectedStartDate = datePickerModel?.beginJsDate;
    this.selectedEndDate = datePickerModel?.endJsDate || datePickerModel?.beginJsDate;
  }

  @Input()
  public placeholder: string;

  @Input()
  public customClass: string = '';

  @Input()
  public clearable: boolean;

  @Output()
  dateChanged: EventEmitter<Ui2DatePickerModel> = new EventEmitter<Ui2DatePickerModel>();

  @Output()
  public focusChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @ViewChild('picker') picker: MatDatepicker<string>;

  public selectedStartDate: Date;
  public selectedEndDate: Date;
  public isOpen: boolean;

  constructor(private readonly datePipe: DatePipe) {}

  public open() {
    this.focusChange.emit(true);
    this.picker.open();
    this.isOpen = true;
  }

  public startDateUpdated() {}

  public endDateUpdated() {
    if (!this.selectedEndDate) {
      return;
    }
    this.dateChanged.emit(buildRangeDateObject(this.selectedStartDate, this.selectedEndDate, this.datePipe));
  }

  public clear() {
    this.picker.close();

    this.selectedStartDate = null;
    this.selectedEndDate = null;

    this.dateChanged.emit(null);
  }
}
